import Flag_en from "./assets/flags/ic_flag_en.svg";
import Flag_ar from "./assets/flags/ic_flag_sa.svg";

export const defaultSettings = {
  themeDirection: "ltr",
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: "English",
    value: "en",
    //icon: Flag_en,
  },
  {
    label: "عربي",
    value: "ar",
    //icon: Flag_ar,
  },
  // {
  //    label: "française",
  //    value: "fr",
  //    // icon: Flag_fr,
  // },
  // {
  //   label: "Vietnamese",
  //   value: "vn",
  //   // icon: Flag_vn,
  // },
  // {
  //   label: "中国人",
  //    value: "cn",
  //   //icon: Flag_cn,
  // },
];

export const defaultLang = allLangs[0]; // English
